/* src/components/quickscan-list/quickscan-list.component.scss */
:host {
  display: block;
  --table-border-size: 1px;
}
.quickscan {
  margin-bottom: var(--vwui-size-spacing-xl);
}
.quickscan-theme {
  margin-bottom: var(--vwui-size-spacing-xl);
}
.quickscan-subject {
  font-weight: 500;
}
.header-subtitle {
  display: block;
  font-size: var(--vwui-size-font-xs);
  font-weight: normal;
}
.nav-item {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  color: var(--color);
  font-weight: var(--vwui--font--semibold);
  margin-bottom: var(--vwui--spacing--xxs);
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease-in-out 0s;
}
.quickscan-col {
  vertical-align: top;
}
.quickscan-col--nr {
  width: 2rem;
}
.quickscan-col--question {
  white-space: normal;
}
.quickscan-col--answer {
  width: 18rem;
  min-width: 18rem;
  max-width: 18rem;
}
.quickscan-col--remark {
  width: 20%;
}
.quickscan-col--remark .textarea {
  display: inline-block;
  vertical-align: top;
  min-height: 3rem;
  width: 100%;
  background: var(--vwui--color--bg);
  border: var(--vwui-border-size-base) solid var(--vwui-border-color-base);
  border-radius: var(--vwui--radius--sm);
  padding: var(--vwui--spacing--xxs) var(--vwui--spacing--xxs);
  color: var(--vwui-color-dark);
  font: inherit;
  transition: all 0.15s ease-in-out;
  resize: vertical;
}
.quickscan-col--remark .textarea:disabled {
  background: var(--vwui-color-neutral-3);
}
.quickscan-col--remark .textarea:focus {
  border: var(--vwui-border-size-base) solid var(--vwui-border-color-focus);
}
.quickscan-col--remark .textarea:hover {
  border-color: var(--vwui-border-color-hover);
}
.quickscan-col--right {
  text-align: right;
}
.quickscan-col--score {
  width: 2rem;
  text-align: right;
}
/*# sourceMappingURL=quickscan-list.component-34W7AUGA.css.map */
